var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._l((_vm.docs),function(groupDoc){return _c('CompanyGroupItem',{key:groupDoc.id,attrs:{"doc":groupDoc}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }